const EuropeanUnionSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111398)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#0052B4"
      />
      <path
        d="M19.9998 7.82715L20.6474 9.82004H22.7427L21.0475 11.0517L21.695 13.0446L19.9998 11.8129L18.3045 13.0446L18.9521 11.0517L17.2568 9.82004H19.3522L19.9998 7.82715Z"
        fill="#FFDA44"
      />
      <path
        d="M11.3916 11.3916L13.2588 12.3429L14.7404 10.8613L14.4125 12.9309L16.2796 13.8822L14.21 14.21L13.8822 16.2797L12.9309 14.4126L10.8613 14.7405L12.343 13.2588L11.3916 11.3916Z"
        fill="#FFDA44"
      />
      <path
        d="M7.82568 19.9998L9.81857 19.3522V17.2568L11.0501 18.9521L13.0431 18.3046L11.8113 19.9998L13.0431 21.695L11.0501 21.0475L9.81857 22.7428V20.6474L7.82568 19.9998Z"
        fill="#FFDA44"
      />
      <path
        d="M11.3916 28.6077L12.3429 26.7405L10.8613 25.2589L12.9309 25.5868L13.8821 23.7197L14.21 25.7893L16.2795 26.1171L14.4127 27.0685L14.7404 29.138L13.2588 27.6564L11.3916 28.6077Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9998 32.1743L19.3521 30.1814H17.2568L18.9521 28.9498L18.3045 26.957L19.9998 28.1886L21.695 26.957L21.0475 28.9498L22.7427 30.1814H20.6473L19.9998 32.1743Z"
        fill="#FFDA44"
      />
      <path
        d="M28.6076 28.6077L26.7405 27.6564L25.2588 29.1381L25.5867 27.0684L23.7197 26.1171L25.7893 25.7893L26.1171 23.7197L27.0683 25.5868L29.1379 25.2589L27.6562 26.7407L28.6076 28.6077Z"
        fill="#FFDA44"
      />
      <path
        d="M32.1728 19.9998L30.1799 20.6474V22.7428L28.9483 21.0475L26.9556 21.695L28.1872 19.9998L26.9556 18.3046L28.9484 18.9521L30.1799 17.2568V19.3523L32.1728 19.9998Z"
        fill="#FFDA44"
      />
      <path
        d="M28.6076 11.3916L27.6563 13.2588L29.1379 14.7404L27.0682 14.4124L26.1171 16.2795L25.7893 14.2099L23.7197 13.882L25.5867 12.9308L25.2588 10.8613L26.7406 12.3429L28.6076 11.3916Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111398">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EuropeanUnionSvg;
